"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayHeaderValue = displayHeaderValue;
exports.summarizeUserAgent = summarizeUserAgent;
/** 解析 User-Agent 为浏览器 / 系统 / 设备类型 */
function summarizeUserAgent(userAgent) {
  if (!userAgent) {
    return '未知设备';
  }
  return "".concat(parseBrowser(userAgent), " / ").concat(parseOs(userAgent), " / ").concat(parseDeviceType(userAgent));
}
function parseBrowser(ua) {
  var edge = ua.match(/Edg\/([\d.]+)/);
  if (edge) return "Edge ".concat(edge[1]);
  var chrome = ua.match(/Chrome\/([\d.]+)/);
  if (chrome && !ua.includes('Edg/')) return "Chrome ".concat(chrome[1]);
  var firefox = ua.match(/Firefox\/([\d.]+)/);
  if (firefox) return "Firefox ".concat(firefox[1]);
  var safari = ua.match(/Version\/([\d.]+).*Safari/);
  if (safari && ua.includes('Safari') && !ua.includes('Chrome')) return "Safari ".concat(safari[1]);
  return '未知浏览器';
}
function parseOs(ua) {
  if (ua.includes('Windows NT 10.0')) return 'Windows 10+';
  if (ua.includes('Mac OS X')) {
    var mac = ua.match(/Mac OS X ([\d_]+)/);
    return mac ? "macOS ".concat(mac[1].replace(/_/g, '.')) : 'macOS';
  }
  if (ua.includes('Android')) {
    var android = ua.match(/Android ([\d.]+)/);
    return android ? "Android ".concat(android[1]) : 'Android';
  }
  if (ua.includes('iPhone')) {
    var ios = ua.match(/iPhone OS ([\d_]+)/);
    return ios ? "iOS ".concat(ios[1].replace(/_/g, '.')) : 'iOS';
  }
  if (ua.includes('Linux')) return 'Linux';
  return '未知系统';
}
function parseDeviceType(ua) {
  if (ua.includes('iPad') || ua.includes('Tablet')) return '平板';
  if (ua.includes('Mobile') || ua.includes('iPhone') || ua.includes('Android')) return '手机';
  return '桌面端';
}
function displayHeaderValue(value) {
  return value && String(value).trim() ? value : '-';
}